import { Component, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef } from '@angular/material/dialog'

import { ButtonComponent } from '../../../../../components/button/button.component'

@Component({
  selector: 'app-salesforce-connect-success',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './salesforce-connect-success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./salesforce-connect-success.component.scss'],
})
export class SalesforceConnectSuccessComponent {
  constructor(
    private dialogRef: MatDialogRef<SalesforceConnectSuccessComponent>,
  ) {}

  close(): void {
    this.dialogRef.close()
  }
}
